// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","yearsOfExperience":"_18Jp8E84EzctLjweOylm5Y"};